import { TBDChatType } from "./PreCoffinChats";

//https://odinsrazor.tumblr.com/  but the password has changed.
export const postCoffinChats:TBDChatType[] = [];

postCoffinChats.push({timestamp: new Date(1994, 7,1,3,22 ),lines: `theBestDude72: hey.
theBestDude72: uh.
theBestDude72: i know you're probably not.
theBestDude72: not getting these.
theBestDude72: i'm not.
theBestDude72: i'm not dumb.
theBestDude72: i understand what the police told me.
theBestDude72: i know it's not.
theBestDude72: not looking good.
theBestDude72: but.
theBestDude72: i'm not going to stop messaging you.
theBestDude72: i'm not going to forget you.
theBestDude72: i promise, dude.`})

postCoffinChats.push({timestamp: new Date(1994, 7,3,10,13 ),lines: `theBestDude72: hey.
theBestDude72: today was wild.
theBestDude72: you're going to be sad you missed it
theBestDude72: janey parker, you remember, from fourth grade?
theBestDude72: she came into the store today.
theBestDude72: you'll never believe how much she's changed.
theBestDude72: she's even taller than i am now
theBestDude72: and she's got bright pink hair
theBestDude72: we hung out for a while.
theBestDude72: i probably talked about you too much.
theBestDude72: but.
theBestDude72: it was nice.
theBestDude72: to talk about you with someone who knew you?
theBestDude72: knows you.
theBestDude72: she REMEMBERS you.
theBestDude72: the guys at work.
theBestDude72: i don't know them and they don't know me.
theBestDude72: i can't talk to them about heavy shit.
theBestDude72: i just want to get back to classes but...
theBestDude72: it won't be the same without you there, dude.
theBestDude72: i hope you find what you're looking for soon.`})

postCoffinChats.push({timestamp: new Date(1994, 7,4,10,12 ),lines: `theBestDude72: i can't do it, dude.
theBestDude72: classes were.
theBestDude72: they were okay.
theBestDude72: but after.
theBestDude72: i never realized how many hours there were in the day.
theBestDude72: i never realized how boring it is to study alone.
theBestDude72: i miss your jokes.
theBestDude72: i miss how you could make anything an adventure.
theBestDude72: get back soon, dude.`})

postCoffinChats.push({timestamp: new Date(1994, 8,12,3,13 ),lines: `theBestDude72: um.
theBestDude72: dude?
theBestDude72: i was just?
theBestDude72: okay.
theBestDude72: let me set the stage for you.
theBestDude72: i was browsing the 'net.
theBestDude72: going down some link holes, you know?
theBestDude72: when i find this weird puzzle.
theBestDude72: and it makes me think of how much you'd like it?
theBestDude72: so i decide to check it out, to like, see if i could recommend it to you?
theBestDude72: and before I know it i'm sucked in?
theBestDude72: i'm not normally one to get all obessed with puzzles but...
theBestDude72: this one caught me...
theBestDude72: it's like it was exactly the right difficulty? 
theBestDude72: i never got frustrated and gave up.
theBestDude72: and then before i know it, i'm at the end?
theBestDude72: and it leads to a instant messaging account.
theBestDude72: so i message it.
theBestDude72: of course i do.
theBestDude72: gotta let you know if it has a satisfying ending.
theBestDude72: and the account messages me BACK.
theBestDude72: so OBVIOUSLY its a bot, right?
theBestDude72: so i start messing with it a bit.
theBestDude72: trying out some key phrases, see if i can't get the next step in the puzzle.
theBestDude72: and the bot is CRAZY responsive, just joking back and forth with me.
theBestDude72: and eventually it dawns on me that theres no way this is a bot?
theBestDude72: but by then i'm just having fun talking to this rando.
theBestDude72: i'd forgotten how nice it feels to just have a normal conversation.
theBestDude72: and the guy is hilarious, you'd love him.
theBestDude72: but yeah...
theBestDude72: apparently he made the puzzles?
theBestDude72: he has this entire elaborate joke about being the CEO of Eyedol Games.
theBestDude72: says he'll hook me up with a job.
theBestDude72: i'm half tempted to call his bluff and just...
theBestDude72: show up at the HQ, all eager to work or whatever it is people do at office jobs.
theBestDude72: if it was you, you'd do it, right?
theBestDude72: go the extra mile for a laugh and to get more info...`})

postCoffinChats.push({timestamp: new Date(1994, 8,15,19,1 ),lines: `theBestDude72: holy shit.
theBestDude72: dude.
theBestDude72: the DAY i have had.
theBestDude72: you would not BELIEVE it.
theBestDude72: first of all? 
theBestDude72: the job offer was LEGIT.
theBestDude72: the CEO of Eyedol FREAKING Games apparently made a puzzle.
theBestDude72: to hire new people?
theBestDude72: i kept thinking it was a prank.
theBestDude72: or like...
theBestDude72: tbh?
theBestDude72: that i was gonna be KILLED.
theBestDude72: i mean...
theBestDude72: these are the guys you were investigating, right?
theBestDude72: because they were hiding the Killer?
theBestDude72: and i kind of...
theBestDude72: mentioned that I thought they killed you...
theBestDude72: during the fucked up 'interview'. 
theBestDude72: so yeah.
theBestDude72: MONDO stressful.
theBestDude72: and thats not even getting into how WEIRD the company is?
theBestDude72: i straight up, swear to the Eight Divine, think its a CULT.
theBestDude72: there were triplets and my manager claimed they were actually...like...
theBestDude72: 19 identical dudes?
theBestDude72: and that the CEO (who apparently is a girl) could see the future or some shit?
theBestDude72: dude, i don't even know what i should do.
theBestDude72: do i quit?
theBestDude72: do i...
theBestDude72: Eight Divine, how do you even set up an Internship?
theBestDude72: am i gonna have to drop out?`});

postCoffinChats.push({timestamp: new Date(1994, 9,16,19,5 ),lines: `theBestDude72: dude.
theBestDude72: today was intense.
theBestDude72: i know im constantly complaining about how weird my internship is.
theBestDude72: and i think i have submitted enough evidence to have earned that right.
theBestDude72: but dude.
theBestDude72: TODAY.
theBestDude72: the ceo had this weird...
theBestDude72: transforming ACTION FIGURE thing sent to me?
theBestDude72: i think its a prototype or something of some Zampanio tie in?
theBestDude72: the thing turns from like, a regular looking dude.
theBestDude72: to a giant floating eye.
theBestDude72: to like...a regular looking business lady?
theBestDude72: my job is to do MARKETING.
theBestDude72: on the INTERNET.
theBestDude72: what am i supposed to do with a toy?
theBestDude72: i can't exactly do a give away online...
theBestDude72: maybe i can just leave it somewhere and claim thats a puzzle.
theBestDude72: leave some clues on a forum or something.
theBestDude72: it gives me the creeps.`});

postCoffinChats.push({timestamp: new Date(1994, 11,16,21,14 ),lines: `theBestDude72: i am going to freaking QUIT This job.
theBestDude72: the holiday party is just the LAST straw, dude.
theBestDude72: i'm just sitting there.
theBestDude72: making awkward small talk with one of the guys who isn't some kind of WEIRD LIVING CHAT BOT.
theBestDude72: steve, i think.
theBestDude72: and i mention the weird dolls we had to market.
theBestDude72: and steve.
theBestDude72: says.
theBestDude72: 'what dolls'
theBestDude72: and i'm looking around, hoping for some backup here.
theBestDude72: and it turns out no one.
theBestDude72: not even any of the Toms.
theBestDude72: has gotten these weird eye transformers.
theBestDude72: just me.
theBestDude72: my manager just grinned and said i'm "the favorite"
theBestDude72: wodin.
theBestDude72: what the FUCK does that mean?
theBestDude72: i can't take this.`});

postCoffinChats.push({timestamp: new Date(1995, 1,14,18,58 ),lines: `theBestDude72: today i discovered one of the meeting rooms.
theBestDude72: had this dude with a ponytail camped out in it.
theBestDude72: claiming he was the ceo of wendys.
theBestDude72: covering every surface in like, conspiracy walls.
theBestDude72: wtf.`});

postCoffinChats.push({timestamp: new Date(1995, 2,21,20,52 ),lines: `theBestDude72: yeah.
theBestDude72: sure.
theBestDude72: why not.
theBestDude72: today we did 'team building'.
theBestDude72: which at Eyedol games.
theBestDude72: apparently means being lost in a hedge maze together for hours.
theBestDude72: the CEO lured us in with the promise of getting options in a hedge fund if we reach the center.
theBestDude72: but she neglected to inform us that only the person who made it out with the fucking fruit basket the options are kept in got to keep them.
theBestDude72: so i spent my day fighting ofF sqwawking idiot clones.
theBestDude72: and at least one actual person.
theBestDude72: and on the one hand?
theBestDude72: yeah i worked out some MONDO frustrations today, wodin.
theBestDude72: but on the other.
theBestDude72: it turns out the hedge fund?
theBestDude72: just invests in industrial companies.
theBestDude72: that create HORSESHOES.
theBestDude72: of all things.
theBestDude72: wodin.
theBestDude72: there's no way this isn't worthless.
theBestDude72: also it turns out options just means you have the OPTION to buy something at a set price.
theBestDude72: not that you get it for free.
theBestDude72: god this job is bullshit.`});

postCoffinChats.push({timestamp: new Date(1995, 10,13,19,7 ),lines: `theBestDude72: so.
theBestDude72: those worthless horseshoe hedgefund stock options.
theBestDude72: quadrupled in price today.
theBestDude72: wtf.
odinsRazor: LIKE I'D GIVE YOU WORTHLESS MAZE PRIZES
theBestDude72: what.
odinsRazor: SHIT`});
